export default "__VITE_ASSET__oWCCtDzo__"